import { Component } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { HttpServiceService } from 'src/app/service/http-service.service';

@Component({
  selector: 'app-taining-categoty',
  templateUrl: './taining-categoty.component.html',
  styleUrls: ['./taining-categoty.component.css']
})
export class TainingCategotyComponent {
  public progressLoader: boolean = false;
  public datasource: any;
  tabledata_header_skip: any = ["_id"];
  tabledata_detail_skip: any = ['_id', 'status', 'usertype'];
  public tabledatatalist: []
  public listprogressBar: any = false;
  tablename = "users";
  editroute = "";
  updateendpoint = "training/trainingcategorystatus";
  deleteendpoint = "training/deletetrainingcategory";
  datacollection: any = "training/trainingcategorylist";

  searchendpoint = "";
  date_search_endpoint: any = "training/trainingcategorylist";
  date_search_source: any = "users";
  date_search_source_count: any = 0;
  Tabledata_header_skip: any = ["_id"];
  limitcond: any = {
    limit: 10,
    skip: 0,
    pagecount: 1,
  };
  statusarray: any = [
    { val: 1, name: "Active" },
    { val: 0, name: "Inactive" },
  ];
  modify_header_array: any = {
    training_category_name: "Category Name",
    training_category_des: "Description",
    training_category_priority: "Priority",
    createdon_datetime: "Created On",
    updatedon_datetime: "Updated On",
    status_text: "Status",
    user_roll: "Role"
  };
  search_settings: any = {


    search: [{
      label: "Search By Category Name", field: '_id',
      serversearchdata: { endpoint: 'training/autocompletetrainingname' },
    },
    ],

    textsearch: [
      { label: "Search By Priority", field: 'priority' },
    ],
    datesearch: [
      {
        startdatelabel: 'Update On Start Date',
        enddatelabel: 'Update On End Date',
        submit: 'Search',
        field: 'updatedon_datetime',
        // value: {$gte: createdon_datetime, $lte: 1622962799000}
      },
    ],
    selectsearch: [
      { label: 'Search By Status', field: 'status', values: this.statusarray },

    ],
  }
  sortdata: any = {
    type: "desc",
    field: "_id",
    options: ["training_category_name", "createdon_datetime", "updatedon_datetime", "status_text", "usertype", "priority"],
  };
  public cookieData: any = {};
  public isAdminUser: boolean = false;
  public isDoctorUser: boolean = false;

  public customlistenbutton: any = {
    flag: true,
    tooltipflag: true,
    buttons: [
      // {
      //   label: 'Add Taxonomies',
      //   type: 'button',
      //   name: 'add_taxonomies',
      //   tooltip: 'Add Taxonomies',
      //   classname: 'add_adminBTN',
      // },
    ],
  }
  libdata: any = {
    basecondition: {},
    detailview_override: [
      { key: "training_category_name", val: "Category Name" },
      { key: "training_category_des", val: "Description" },
      { key: "createdon_datetime", val: "Created On" },
      { key: "updatedon_datetime", val: "Updated On" },
      { key: "training_category_priority", val: "Priority" },
      { key: "status_text", val: "Status" },
      { key: "user_roll_txt", val: "Role" }


    ],
    updateendpoint: "training/trainingcategorystatus",

    hidedeletebutton: false,
    hideviewbutton: false,
    hideeditbutton: true,
    hidestatustogglebutton: false,
    hidemultipleselectbutton: false,
    hideaction: false,
    updateendpointmany: "training/trainingcategorystatus",

    deleteendpointmany: "training/deletetrainingcategory",
    tableheaders: ["training_category_name", "training_category_des", "createdon_datetime", "training_category_priority", "user_roll", "status_text", "updatedon_datetime"],


    custombuttons: [
      {
        label: "Edit",
        type: 'listner',
        id: 'edit_btn',
        tooltip: 'Edit',
        name: 'edit',
        classname: 'edit_btn'
      },
      {
        label: "Preview",
        type: 'action',
        datatype: 'api',
        endpoint: 'training/previewtrainingcategory',
        otherparam: [],
        // cond:'status',
        // condval:0,
        param: '_id',
        datafields: ['training_category_name', 'training_category_des', 'training_category_priority', 'createdon_datetime', 'user_roll_txt', 'updatedon_datetime', 'status'],
        //  refreshdata: true,
        headermessage: 'Preview',
        tooltip: 'Preview',
        classname: 'previewButton'
      },
    ],

  }
  public taxonomy_updatetable: boolean = false;
  public api_url_for_managebanner = this.httpService.baseUrl;
  public jwttokenformanagebanner = this.httpService.jwtToken;

  constructor(private httpService: HttpServiceService, public router: Router, public activatedRoute: ActivatedRoute, private _bottomSheet: MatBottomSheet, public cookieService: CookieService) {
    if (!window.location.pathname.includes('training')) {
      this.router.navigateByUrl('404')
    }
    if (this.cookieService.getAll()['login_user_details']) {
      this.cookieData = JSON.parse(this.cookieService.getAll()['login_user_details']);
    }
  }
  ngOnInit() {
    this.categoryListFetching();
  }
  categoryListFetching() {
    let data = {
      condition: {
        limit: 10,
        skip: 0,
      },
      sort: {
        type: 'desc',
        field: '_id'
      },
      searchcondition: {}
    }

    this.activatedRoute.data.subscribe((response: any) => {
      console.log("activatedRoute", response)
      this.listprogressBar = true
      if (response) {
        this.tabledatatalist = response.data.results.res;
        setTimeout(() => {
          this.listprogressBar = false
        }, 150);

      }
    })

    this.httpService.httpViaPost('training/trainingcategorylist-count', data).subscribe((response: any) => {
      // console.log(response)
      if (response) {
        this.date_search_source_count = response.count;
      }

      // this.progressLoader = false;
    })

    // httpService: ;


    console.log("this.tabledatatalist", this.tabledatatalist)

  }
  addBtn() {
    this.router.navigateByUrl(`${this.cookieData.user_type}/training/training-category-add`);
  }

  onLiblistingButtonChange(data: any) {
    // throw new Error('Function not implemented.');
    console.log("test>>>>>>>", data);
    this.router.navigateByUrl(`admin/ttraining/training-category-add`);

  }
  listenLiblistingChange(data: any = null) {
    if (data.action == "custombuttonclick") {
      if (data.custombuttonclick.btninfo.id == 'edit_btn') {
        this.editListItem(data.custombuttonclick.data);
      }
    }
    if (data.action == "statusupdate") {
      if (data.totalresults && data.totalresults.status == "success") {
        this.taxonomy_updatetable = !this.taxonomy_updatetable;
      }
    }
  }
  editListItem(item: any) {
    if (item) {
      console.log("Op=====>1", item);
      this.router.navigateByUrl(`${this.cookieData.user_type}/training/training-category-edit/${item._id}`);
    }
  }
}
